module.exports = __webpack_public_path__ + "img/77313.1ee5be74.svg";